import React from 'react';
import { Dialog, T } from '@colonist/ui';
const COPY_BUTTON_LABELS = {
    copy: 'strings:game.endGame.shareImagePopup.copy',
    copied: 'strings:game.endGame.shareImagePopup.copied',
    cantCopy: 'strings:game.endGame.shareImagePopup.cantCopy'
};
/* Action buttons for the share image dialog */ export const ShareImageDialogFooter = ({ footer, onFooterAction })=>{
    if (footer.layout == 'copyAndDownload') {
        return /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
            onClick: ()=>onFooterAction('download')
        }, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.endGame.shareImagePopup.download'
            }
        })), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
            onClick: ()=>onFooterAction('copy')
        }, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: COPY_BUTTON_LABELS[footer.copyButtonState]
            }
        })));
    }
    if (footer.layout == 'shareOnly') {
        return /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
            onClick: ()=>onFooterAction('share')
        }, /*#__PURE__*/ React.createElement(T, {
            id: footer.shareButtonLabel
        })));
    }
    if (footer.layout == 'shareWithOptionalReplay') {
        return /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
            onClick: ()=>onFooterAction('share')
        }, /*#__PURE__*/ React.createElement(T, {
            id: footer.shareButtonLabel
        })), footer.showReplayButton && /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
            onClick: ()=>onFooterAction('shareReplay')
        }, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.endGame.shareImagePopup.mobile.shareReplayButtonText'
            }
        })));
    }
    return null;
};
